var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright © Callrobo For Clinic All Rights Reserved.")])])
}]

export { render, staticRenderFns }